var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "flex-column" },
    [
      _c("resizable-text-area", {
        staticClass: "w-100",
        staticStyle: { "min-height": "100px" },
        attrs: {
          id: "declineReasonTextarea",
          rows: "3",
          "maximum-height": 100,
          "max-length": "4000",
        },
        model: {
          value: _vm.text,
          callback: function ($$v) {
            _vm.text = $$v
          },
          expression: "text",
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "d-none", attrs: { for: "declineReasonTextarea" } },
        [_vm._v("Textarea")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }